import React from 'react';
import thumbImg from '../assets/images/thumb.jpg'; 
import pfpImg from '../assets/images/pfp.png';
import { Ticket, BadgePercent } from 'lucide-react';

function MenuHeader() {
    return (
        <div className="w-full bg-[#FFF5EE] pb-6">
            {/* Capa com Overlay */}
            <div className="relative w-full h-48 md:h-72 bg-stone-900">
                <img src={thumbImg} alt="Capa" className="absolute inset-0 w-full h-full object-cover opacity-50 mix-blend-overlay" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                
                {/* Badges Flutuantes no Topo/Direita */}
                <div className="absolute top-4 right-4 flex flex-col md:flex-row gap-2 items-end md:items-center">
                    <span className="flex items-center gap-1.5 bg-[#dbcdac] text-[#971253] text-xs md:text-sm font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg">
                        <Ticket size={16} /> Passaporte R$ 15
                    </span>
                    <span className="flex items-center gap-1.5 bg-[#528a89] text-white text-xs md:text-sm font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg">
                        <BadgePercent size={16} /> Sem Taxa de Serviço
                    </span>
                </div>
            </div>

            {/* Profile Section (Sobrepondo a imagem) */}
            <div className="max-w-5xl mx-auto px-6 relative -mt-16 md:-mt-20 flex flex-col md:flex-row items-center md:items-end gap-4 md:gap-6 text-center md:text-left">
                <div className="shrink-0 rounded-full border-4 border-[#FFF5EE] bg-white p-1 shadow-xl">
                    <img src={pfpImg} alt="Logo Deli da Persy" className="w-28 h-28 md:w-40 md:h-40 rounded-full object-cover" />
                </div>
                
                <div className="flex-1 pb-2">
                    <h1 className="font-serif text-4xl md:text-5xl text-[#971253] font-bold mb-1">Deli da Persy</h1>
                    <p className="text-stone-500 font-medium tracking-wide text-sm md:text-base uppercase flex items-center justify-center md:justify-start gap-2">
                        <span>Board Game Café</span> <span className="text-[#dbcdac]">•</span> <span>Lanches</span> <span className="text-[#dbcdac]">•</span> <span>RPG</span>
                    </p>
                </div>
            </div>
        </div>
    );
}
export default MenuHeader;